"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAcceptFormGuidedFlowOffsets = exports.getSignatureSlotGuidedFlowOffsets = exports.getStartGuidedFlowOffsets = exports.getFirstContentVerticalOffset = exports.getElementSelector = exports.getNextPendingStep = exports.getScrollOptionsByStepType = exports.makeGuidableText = exports.getGuidableStepsFromTokens = void 0;
var lodash_1 = require("lodash");
var modalHeaderNumberHeight = 62;
function getWidgetId(token) {
    var widgetId = token["widgetId"];
    if (typeof widgetId === "object" && "id" in widgetId && widgetId.id) {
        return widgetId.id;
    }
    else if (typeof widgetId === "string" && widgetId) {
        return widgetId;
    }
}
var getGuidableStepsFromTokens = function (tokens) {
    var inlineWidgetTypes = ["signature", "initials"];
    return tokens
        .filter(function (token) { return token.type === "block" && inlineWidgetTypes.includes(token.subType) && !!getWidgetId(token); })
        .map(function (token) { return ({
        id: getWidgetId(token),
        type: "widget",
        subType: token.subType,
    }); });
};
exports.getGuidableStepsFromTokens = getGuidableStepsFromTokens;
var makeGuidableText = function (subType) {
    switch (subType) {
        case "signature": {
            return "Sign";
        }
        case "initials": {
            return "Initial";
        }
        case "accept-form": {
            return "Fill in";
        }
        default: {
            return "Action required";
        }
    }
};
exports.makeGuidableText = makeGuidableText;
var getScrollOptionsByStepType = function (type) {
    switch (type) {
        case "signature":
        case "initials": {
            return { behavior: "smooth", block: "end", scrollMode: "always" };
        }
        case "accept-flow": {
            return { behavior: "smooth", block: "start", scrollMode: "always" };
        }
        default: {
            return { behavior: "smooth", block: "center", scrollMode: "if-needed" };
        }
    }
};
exports.getScrollOptionsByStepType = getScrollOptionsByStepType;
var getNextPendingStep = function (steps, startFrom) {
    var _a, _b, _c, _d;
    var hasPending = steps.some(function (step) { return step.completed === false; });
    if (!hasPending) {
        return null;
    }
    var startIndex = 0;
    if (startFrom) {
        var idx = steps.findIndex(function (step) {
            return step.id === startFrom;
        });
        startIndex = idx > -1 ? idx : 0;
    }
    var predicate = function (step) {
        return step.completed === false;
    };
    var nextIndex = (0, lodash_1.findIndex)(steps, predicate, startIndex);
    if (nextIndex !== -1) {
        return (_b = (_a = steps[nextIndex]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
    }
    var loopedNextIndex = (0, lodash_1.findIndex)(steps.slice(0, startIndex), predicate);
    return (_d = (_c = steps[loopedNextIndex]) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null;
};
exports.getNextPendingStep = getNextPendingStep;
var getElementSelector = function (type, id) {
    if (type === "widget") {
        return "[data-widget-id=\"".concat(id, "\"]");
    }
    return "[data-qwilr-component=\"".concat(id, "\"]");
};
exports.getElementSelector = getElementSelector;
var getFirstContentVerticalOffset = function (firstContentChild) {
    var _a;
    if (!firstContentChild || !((_a = firstContentChild.textContent) === null || _a === void 0 ? void 0 : _a.length)) {
        return 0;
    }
    var textHeight = firstContentChild
        ? parseFloat(window.getComputedStyle(firstContentChild).getPropertyValue("line-height").replace("px", ""))
        : 0;
    return textHeight / 2;
};
exports.getFirstContentVerticalOffset = getFirstContentVerticalOffset;
var getStartGuidedFlowOffsets = function (_a) {
    var _b, _c;
    var contentColumnsElement = _a.contentColumnsElement, buttonWidth = _a.buttonWidth, buttonHeight = _a.buttonHeight;
    var firstContentChild = (_b = contentColumnsElement === null || contentColumnsElement === void 0 ? void 0 : contentColumnsElement.children[0]) === null || _b === void 0 ? void 0 : _b.children[0];
    var x = ((_c = contentColumnsElement === null || contentColumnsElement === void 0 ? void 0 : contentColumnsElement.offsetLeft) !== null && _c !== void 0 ? _c : 0) - buttonWidth;
    var y = contentColumnsElement.offsetTop - buttonHeight / 2 + (0, exports.getFirstContentVerticalOffset)(firstContentChild);
    return { x: x, y: y };
};
exports.getStartGuidedFlowOffsets = getStartGuidedFlowOffsets;
var getSignatureSlotGuidedFlowOffsets = function (_a) {
    var isMobileDevice = _a.isMobileDevice, targetSlot = _a.targetSlot, contentColumnsElement = _a.contentColumnsElement, guidableElement = _a.guidableElement, buttonWidth = _a.buttonWidth, buttonHeight = _a.buttonHeight, blockContainerSelector = _a.blockContainerSelector;
    var spacerElement = document.querySelector("".concat(blockContainerSelector, " .block-spacer"));
    var blockPadding = spacerElement
        ? parseFloat(window.getComputedStyle(spacerElement).getPropertyValue("padding-top").replace("px", ""))
        : 0;
    if (isMobileDevice) {
        var x_1 = targetSlot.getBoundingClientRect().left + targetSlot.clientWidth / 2 - buttonWidth / 2;
        var y_1 = targetSlot.offsetTop - blockPadding + 10;
        return { x: x_1, y: y_1 };
    }
    var x = contentColumnsElement.offsetLeft + guidableElement.offsetLeft - buttonWidth;
    var y = guidableElement.offsetTop + blockPadding + buttonHeight / 2;
    return { x: x, y: y };
};
exports.getSignatureSlotGuidedFlowOffsets = getSignatureSlotGuidedFlowOffsets;
var getAcceptFormGuidedFlowOffsets = function (_a) {
    var isMobileDevice = _a.isMobileDevice, guidableElement = _a.guidableElement, firstAcceptFormInput = _a.firstAcceptFormInput, buttonWidth = _a.buttonWidth, buttonHeight = _a.buttonHeight;
    if (isMobileDevice) {
        var x_2 = guidableElement.offsetLeft + guidableElement.clientWidth / 2 - buttonWidth / 2;
        var y_2 = guidableElement.offsetTop - modalHeaderNumberHeight - buttonHeight / 2;
        return { x: x_2, y: y_2 };
    }
    var x = guidableElement.offsetLeft - buttonWidth;
    var y = guidableElement.offsetTop +
        firstAcceptFormInput.offsetTop +
        firstAcceptFormInput.clientHeight / 2 -
        buttonHeight / 2 -
        modalHeaderNumberHeight;
    return { x: x, y: y };
};
exports.getAcceptFormGuidedFlowOffsets = getAcceptFormGuidedFlowOffsets;
